import { render, staticRenderFns } from "./ConfirmarDados.vue?vue&type=template&id=1dcbd9f0&scoped=true"
import script from "./ConfirmarDados.vue?vue&type=script&lang=js"
export * from "./ConfirmarDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcbd9f0",
  null
  
)

export default component.exports